import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { ErrorHandler } from "../../../Helpers/ErrorHandler";
import productService from "../../../Services/productService";

export const useFetchCategoryProducts = (catUuid:string|undefined, pageNumber:number, sortOrder:string) => {
  const context = useQuery(["fetchBrandsProducts"], () => productService.getAllCategoryProduct(catUuid, pageNumber, sortOrder),
    {
      enabled: true,
      retry: false,
      select: (data:{ data: { data:{ dataset:any[], pageNumber: number, pageSize: number, total: number } } }) => data.data.data,
      onSuccess (data) {
        // toast.success("success", { duration: 20000, className: 'custom-alert bg-white text-dark', position: "top-right" });
      },
      onError (error: any) {
        if (Array.isArray((error as any).data.error)) {
          (error as any).data.error.forEach((el: any) =>
            ErrorHandler(error,
              () => {
                toast.error(error.response.data.error, { duration: 20000, className: 'custom-alert bg-white text-dark', position: "top-right" });
              })
          );
        } else {
          ErrorHandler(error,
            () => {
              toast.error(error.response.data.error, { duration: 20000, className: 'custom-alert bg-white text-dark', position: "top-right" });
            })
        }
      },
    }
  );

  return context;
};
